import { ListingSettingsApiErrorMessages } from 'src/admin/pricing/types/ListingSettingsApiErrors';

// order must match [Locale.getWeekInfo().firstDay](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo)
export const WEEK_DAY_NAMES = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'] as const;

/*
order matches [Locale.getWeekInfo().firstDay](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/getWeekInfo)
*/
export const DAY_MAP: { [T in typeof WEEK_DAY_NAMES[number]]: {
  abbr: string;
  /* Locale.getWeekInfo().firstDay order */
  order: number;
  /* Only provided if different from order. Index based on Date.getDay() (sun..sat, 0..6) */
  dayOrder?: number;
} } = {
  monday: { abbr: 'Mo', order: 1 },
  tuesday: { abbr: 'Tu', order: 2 },
  wednesday: { abbr: 'We', order: 3 },
  thursday: { abbr: 'Th', order: 4 },
  friday: { abbr: 'Fr', order: 5 },
  saturday: { abbr: 'Sa', order: 6 },
  sunday: { abbr: 'Su', order: 7, dayOrder: 0 },
};

/** hours */
export const MAX_DURATION = 12;

/** multi day */
export const PERIOD_DAY = 'PERIOD_DAY';
export const PERIOD_NIGHT = 'PERIOD_NIGHT';
export const MIN_NIGHTS = 1;
export const MAX_NIGHTS = 31;
export const MIN_DAYS = 2;
export const MAX_DAYS = 30;

export const SEASON_THEME_PALETTE_COUNT = 15;
export const SEASON_THEME_PALETTE_SWATCH_COUNT = 3;

export const DEFAULT_CAPTAIN_PRICE = 0;
/** Backend will throw on undefined, expects 0 as default */
export const DEFAULT_HOURLY_CAPTAIN_RATE = 0;

/** Known rule IDs from the backend */
export const RULE_IDS = {
  operating_hours_validation: 'operating_hours_validation',
  at_least_one_pricing_config: 'at_least_one_pricing_config',
  unique_durations_same_day_prices: 'unique_durations_same_day_prices',
  unique_min_max_durations_multi_day_prices: 'unique_min_max_durations_multi_day_prices',
  unique_multi_day_period: 'unique_multi_day_period',
} as const;

export const LISTING_SETTINGS_API_ERRORS: ListingSettingsApiErrorMessages = {
  [RULE_IDS.operating_hours_validation]: 'Departure time cannot be after return time.',
  [RULE_IDS.at_least_one_pricing_config]: 'At least one pricing configuration is required',
  [RULE_IDS.unique_durations_same_day_prices]: 'Durations must be unique for same day prices',
  [RULE_IDS.unique_min_max_durations_multi_day_prices]: 'Min and max durations must be unique for multi day prices',
  [RULE_IDS.unique_multi_day_period]: 'Multi day price period must be either daily or nightly',
  generalError: 'An error occurred while saving the listing settings',
};
